export const toIntNullSafe = (i) => {
    const numberAsString = `${i}`;
    if (/^[1-9][0-9]*$/.test(numberAsString)) {
        return parseInt(`${i}`, 10);
    }
    else {
        return 0;
    }
};
export const sanitizeUserInput_fieldId = (fieldId) => {
    return `${fieldId}`.replace(/[^-_.0-9a-zA-Z]/g, '');
};
export const sanitizeUserInput_optionId = (id) => {
    return `${id}`.replace(/[^-_.0-9a-zA-Z]/g, '');
};
export const sanitizeUserInput_contextId = (id) => {
    return `${id}`.replace(/[^-_.0-9a-zA-Z]/g, '');
};
export const sanitizeUserInput_groupId = (id) => {
    return `${id}`.replace(/[^-:_.0-9a-zA-Z]/g, '');
};
export const sanitizeUserInput_accountId = (id) => {
    return `${id}`.replace(/[^-:_.0-9a-zA-Z]/g, '');
};
export const sanitizeUserInput_positiveNumber = (nmbr) => {
    return `${nmbr}`.replace(/[^0-9]/g, '');
};
export const byteSizeOfJsonObject = (o) => {
    return Buffer.byteLength(JSON.stringify(o), 'utf8');
};
//
// STRING TYPES THAT SHOULD ALLOW UNICODE LETTERS TOO!
//
export const sanitize_userOrGroupPickerQuery = (query) => {
    // Allow only spaces, letters and numbers => unicode => https://javascript.info/regexp-unicode
    return `${query}`.replace(/[^-:.,;_\p{Zs}\p{L}\p{N}]/gu, '');
};
export const sanitizeUserInput_filter = (filter) => {
    // Allow only spaces, letters and numbers => unicode => https://javascript.info/regexp-unicode
    return `${filter}`.replace(/[^-:.,;_\p{Zs}\p{L}\p{N}]/gu, '');
};
export const generateErrorMessageFromErrorAndPayloadCustomFields = (errorAndPayloadCustomFields) => {
    return `${errorAndPayloadCustomFields.statusCode} - ${errorAndPayloadCustomFields.errorMessage} - ${errorAndPayloadCustomFields.payload ? JSON.stringify(errorAndPayloadCustomFields.payload, null, 2) : 'NOPAYLOAD'}`;
};
